import React from 'react'
import PropTypes from 'prop-types'
import ItemHeader from '../ItemHeader'
import Slider from '../../../Slider'
import sliders from '../../../../templates/sliders'

const MobileUploadItem = ({ mediaLength, numberOfFiles, onChange, remove }) => {
    return (
        <div>
            <ItemHeader title={`Mobile uploads`} remove={remove} />
            <Slider
                {...sliders.averageMediaLength}
                value={mediaLength}
                onChange={value => onChange(item => (item.mediaLength = value))}
            />

            <Slider
                {...sliders.numberOfFiles}
                value={numberOfFiles}
                onChange={value =>
                    onChange(item => (item.numberOfFiles = value))
                }
            />
        </div>
    )
}

MobileUploadItem.propTypes = {
    mediaLength: PropTypes.number,
    numberOfFiles: PropTypes.number,
    onChange: PropTypes.func,
    remove: PropTypes.func
}

export default MobileUploadItem
